import { ApiService }       from '../../app-lite/api/api.service';
import { CodeTypeModel }    from '../../app-lite/core/models/code-type';
import { ConfirmService }   from '../../app-lite/messages/confirm/confirm.service';
import { SessionService }   from '../../app-lite/sessions/session.service';
import { UserModel }        from '../../app-lite/users/models/user';
import { UserPasswordInfo } from './models/user.password-info';
import { XeroService }      from '../../app-lite/xero/xero.service';

interface UserSettingsScope extends ng.IScope {
  celero            : any;
  changePassword    : ( form : ng.IFormController ) => void;
  disconnectXero    : () => void;
  isXeroUserVerified: () => boolean;
  jobCardOptions    : Array<CodeTypeModel>;
  passwordInfo      : UserPasswordInfo;
  save              : ( form : ng.IFormController ) => void;
  settings          : any;
  terminals         : Array<any>;
  user              : UserModel;
  verifyXero        : () => void;
}

export function UserSettingsCtrl (
  $scope       : UserSettingsScope,
  $state       : ng.ui.IStateService,
  $translate   : ng.translate.ITranslateService,
  $window      : ng.IWindowService,
  Celero       : any,
  confirm      : ConfirmService,
  messages     : any,
  sessionObjAPI: SessionService,
  user         : UserModel,
  workshopAPI  : ApiService,
  xeroApi      : XeroService
) {

  $scope.celero    = new Celero();
  $scope.settings  = sessionObjAPI.user();
  $scope.terminals = [];
  $scope.user      = user;

  $scope.passwordInfo = {
    confirm_password: '',
    new_password    : '',
    old_password    : ''
  };

  $scope.jobCardOptions = [
    {
      code          : true,
      language_label: 'JS_SPACE.USER_SETTINGS.ALWAYS'
    },
    {
      code          : false,
      language_label: 'JS_SPACE.USER_SETTINGS.NEVER'
    },
    {
      code          : null,
      language_label: 'JS_SPACE.USER_SETTINGS.ASK_ME_EVERY_TIME'
    }
  ];

  $scope.changePassword = function ( form : ng.IFormController ) {
    workshopAPI.post('/users/change_password', $scope.passwordInfo)
    .then(response => {
      $scope.passwordInfo = {
        confirm_password: '',
        new_password    : '',
        old_password    : ''
      };

      form.$setPristine();

      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.SAVE_SUCCESSFUL'), 'success');
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.disconnectXero = function () {
    confirm.generic($translate.instant('COMPANY_SPACE.INTEGRATIONS.XERO.CONFIRM_USER_DISCONNECT'))
    .then(() => xeroApi.disconnectUser($scope.user))
    .then(() => {
      messages.show($translate.instant('COMPANY_SPACE.INTEGRATIONS.XERO.USER_DISCONNECTED'), 'success');

      $state.reload();
    })
    .catch(( err : any ) => {
      messages.error(err);
    });
  };

  $scope.isXeroUserVerified = function () {
    return xeroApi.isUserVerified($scope.user);
  };

  $scope.save = function ( form : ng.IFormController ) {
    workshopAPI.patch('/user', $scope.settings, 'user')
    .then(() => sessionObjAPI.refresh())
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.SAVE_SUCCESSFUL'), 'success');

      $scope.settings = sessionObjAPI.user();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.verifyXero = function () {
    $window.location.assign(xeroApi.getVerifyUserUrl());
  };

  $scope.celero.getTerminals()
  .then(( terminals : Array<any> ) => {
    $scope.terminals = terminals;
  });

  if (xeroApi.wasUserVerificationAttempted() && xeroApi.didUserVerificationSucceed()) {
    messages.show($translate.instant('COMPANY_SPACE.INTEGRATIONS.XERO.USER_VERIFIED'))
  }
  else if (xeroApi.wasUserVerificationAttempted()) {
    xeroApi.showVerificationError()
    .finally(() => {
      $state.go('app.user-settings',{
        code                   : null,
        xero_request_successful: null
      }, {
        inherit: false,
        reload : true
      });
    });
  }
}